import React from 'react';
import {connect, WithStore, MapStateToProps, MapDispatchToProps} from '../../redux/services/Imports';
import './PageVacancy.scss';
import './PageVacancy-media.scss';
import './../../components/Back/Back.scss';
import './../../components/Back/Back-media.scss';
import {Props} from './interfaces';
import Content from '../../components/Content/Content';
import Page404 from '../404/404';
import FormVacancy from '../../components/FormVacancy/FormVacancy';

const PageVacancy = ({
                       state404,
                       vacancyTitle
                     }: Props) => {

  if (state404) {
    return <Page404/>;
  }

  return (
    <Content
      block={<FormVacancy vacancyTitle={vacancyTitle} />}
    />
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(PageVacancy));
